var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-pages-editor"},[_c('WebPagesEditorForm'),_c('WebPagesBuilder'),_c('WebPagesEditorActions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }